module.exports = __webpack_public_path__ + "fb551178f4037205391ae253e8ee4808.svg";